<div *cftI18n="let t">
  <div class="flex flex-wrap">
    @for (file of selectedFiles; track file.fileKey) {
      <div class="thumbnail-card">
        <div>
          @if (file | cftIsImage) {
            @if (file.url | cftIsBlob) {
              <img
                class="image-preview"
                [src]="file.url"
                (load)="imageLoadedOnPage(file)"
                alt=""
                (click)="openGallery(file)"
              />
            } @else {
              <img
                class="image-preview"
                [ngSrc]="file.url"
                width="180"
                height="216"
                alt=""
                (click)="openGallery(file)"
              />
            }
          } @else if (file | cftIsPdf) {
            <cft-file-preview [file]="file" [icon]="pdfIcon" />
          } @else {
            <cft-file-preview [file]="file" [icon]="otherFileIcon" />
          }
        </div>
        <div class="flex flex-row items-center gap-sm p-md">
          <span class="filename">
            @if (file.originalFilename) {
              {{ file.originalFilename }}
            }
          </span>
          @if (file.uploaded && !control?.disabled && canDelete) {
            <div (click)="removeFile(file)" class="min-w-2 cursor-pointer whitespace-nowrap">
              <fa-icon [icon]="removeIcon"></fa-icon>
            </div>
          }
          @if (file.error) {
            <div class="icon error-icon">
              <fa-icon [icon]="errorIcon"></fa-icon>
            </div>
          }
          @if (file.uploaded && !canDelete) {
            <div class="icon uploaded-icon">
              <fa-icon [icon]="uploadedIcon"></fa-icon>
            </div>
          }
          @if (!file.uploaded && !file.error) {
            <div class="h-6 w-6">
              <cft-spinner></cft-spinner>
            </div>
          }
        </div>
      </div>
    }
  </div>
  @if (canUpload) {
    <div (click)="fileInput?.click()" class="upload-button" [class.mt-md]="selectedFiles.length > 0">
      <div>
        <div class="text-base font-semibold text-primary">
          <fa-icon size="lg" [icon]="uploadIcon" class="mr-md"></fa-icon>
          <span>{{ uploadLabel ?? t('files.uploadButton') }}</span>
        </div>
      </div>
      <div class="mt-xs text-xs text-grey-400">
        {{ t('files.supportedFileTypesMessage', {types: supportedExtensions()}) }}
      </div>
    </div>
  }
  @if (canUpload) {
    <div class="mt-md">
      @if (hasUploadErrors) {
        <div class="error">
          {{ t('files.errors.fileUploadFailed') }}
        </div>
      }
      @if (hasRemovalErrors) {
        <div class="error">
          {{ t('files.errors.fileRemovalFailed') }}
        </div>
      }
      @if (control?.invalid && control?.touched) {
        <div class="error">
          <ng-content select="[content=error]"></ng-content>
        </div>
      }
    </div>
  }
  <cft-file-input
    #fileInput
    [formControl]="control | bgoAsFormControl"
    [multiple]="canSelectMultiple"
    [accept]="accept()"
    [generateUploadLink]="generateUploadLink"
    [disabled]="!!control?.disabled"
    (fileUploaded)="setFileWasUploaded($event)"
    [id]="id"
  ></cft-file-input>
</div>

<!-- # todo PREVIEW for pdfs. The below works but doesn't look nice in all browsers. Probably need to go with third-party library eventually-->
<!-- <object
[data]="file.url + '#toolbar=0&navpanes=0&scrollbar=0&messages=0&statusbar=0' | safe"
class="h-20 max-w-20 rounded-sm relative object-cover"
type="application/pdf"
></object>-->
